<div class="ModalTabSubConPage">
    <h1>Medication</h1>

    <div class="possibleDiagnosis previewTabLeftContent diagnosis" [innerHtml]="MedicationComponentDataset"></div>

    

    </div>